import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { StoreService } from '@root/shared/service/store.service';
import { HttpCalendarService } from './http-calendar.service';
import { DateService } from '@root/shared/service/date.service';
export const holidayKey = 'hostex_holiday_2019';

export class DateModel {
  date: string;
  i18nDate: string;
  number: number;
  day: number;
  value: Moment;
  isLastMonth: boolean;
  isNextMonth: boolean;
  isCurrentDay: boolean;
  isPastDate: boolean;
  isLegalHoliday: boolean;
  isOff: boolean;
  holidayName: string;
  offsetStart: number;
  firstDayOffsetStart?: number;
  data?: any;
  week: number;
  constructor(options?: any) {
    this.date = options.date || '';
    this.i18nDate = options.i18nDate || '';
    this.number = options.number || 0;
    this.day = options.day || 0;
    this.value = options.value || null;
    this.isLastMonth = options.isLastMonth || false;
    this.isNextMonth = options.isNextMonth || false;
    this.isCurrentDay = options.isCurrentDay || false;
    this.isPastDate = options.isPastDate || false;
    this.isLegalHoliday = options.isLegalHoliday;
    this.isOff = options.isOff;
    this.holidayName = options.holidayName;
    this.offsetStart = options.offsetStart || 0;
    this.firstDayOffsetStart = options.firstDayOffsetStart || 0;
    this.data = options.data || null;
    this.week = options.week;
    // [{
    //   date: 1111-11-11,
    //   reservation: '1111'
    // }]
  }
  get dayName() {
    // return ["日", "一", "二", "三", "四", "五", "六"][this.day];
    return [
      'operate.sunday',
      'operate.monday',
      'operate.tuesday',
      'operate.wednesday',
      'operate.thursday',
      'operate.friday',
      'operate.saturday',
    ][this.day];
  }
  get month() {
    return this.value.month() + 1;
  }
}

export class RowModel {
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class CalendarBuilder {
  rangeStart: Moment = moment().subtract(1, 'year').startOf('d');
  rangeEnd: Moment = moment().add(2, 'year').startOf('d');
  constructor(
    private storeService: StoreService,
    private calendarService: HttpCalendarService,
    private dateService: DateService
  ) {}

  /** 构建一个起始时间为date，长度为length的日历数组 */
  buildCalendar(_date: Moment, length: number) {
    let date = _date.clone();
    const holidays = this.calendarService.getHolidayData();
    const days: Array<DateModel> = [];
    for (let i = 0; i < length; i++) {
      const offsetStart = this.offsetDays(this.rangeStart, date);
      const holiday = holidays && holidays[date.format('YYYY-MM-DD')];
      const holidayName = holiday && holiday.name;
      const isLegalHoliday = holiday && holiday.isLegalHoliday;
      const isOff = holiday && holiday.isOff;
      days.push(
        new DateModel({
          date: date.format('YYYY-MM-DD'),
          i18nDate: this.dateService.format(date, ['MD']),
          value: date,
          number: date.date(),
          day: date.day(),
          week: date.week(),
          isLastMonth: date.month() < moment().month(),
          isNextMonth: date.month() > moment().month(),
          isCurrentDay: date.isSame(moment(), 'day'),
          isPastDate: date.isBefore(moment(), 'day'),
          isLegalHoliday: isLegalHoliday,
          isOff: isOff,
          holidayName: holidayName,
          offsetStart: offsetStart,
          // firstDayOffsetStart: firstDayOffsetStart
        })
      );

      date = date.clone();
      date.add(1, 'd');
    }
    return days;
  }

  /** 获取start和end之间的所有月份 */
  getAllMonth() {
    const count = this.rangeEnd.diff(this.rangeStart, 'months');
    const result = [];
    const date = this.rangeStart.clone();
    for (let i = 0; i < count; i++) {
      result.push({
        title: date.format('YYYY年MM月'),
        // title: this.dateService.format(date, ['YM']),
        date: date.format('YYYY-MM'),
        i18nTitle: this.dateService.format(date, ['YM']),
        value: date.clone(),
      });
      date.add(1, 'M');
    }
    return result;
  }
  /** 获取start和end之间的所有年份 */
  getAllYear() {
    const count = this.rangeEnd.diff(this.rangeStart, 'years');
    const result = [];
    const date = this.rangeStart.clone();
    for (let i = 0; i <= count; i++) {
      result.push({
        // title: date.format("YYYY年"),
        date: date.format('YYYY'),
        i18nTitle: date.format('YYYY'),
        value: date.clone(),
      });
      date.add(1, 'y');
    }
    return result;
  }

  /** 计算day到start之间的总天数 */
  offsetDays(start: Moment, day: Moment) {
    return moment(day).diff(moment(start), 'd');
  }

  offsetStart(day: Moment | string) {
    return this.offsetDays(this.rangeStart, moment(day, 'YYYY-MM-DD'));
  }

  /** 计算总天数 */
  totalDays() {
    return this.offsetDays(this.rangeStart, this.rangeEnd);
  }

  /** end与start之间共跨了几个月 */
  crossMonthCount(start: Moment, end: Moment) {
    return end.month() - start.month();
  }

  /** 对buildcalendar的封装 */
  buildDefaultCalendar() {
    return this.buildCalendar(this.rangeStart, this.totalDays());
  }
}
